<div>
    <div>
      <b>You are impersonating, {{ currentUser.MemberName }}, {{ currentUser.Username }}. When you are finished, select "Stop Impersonating" </b>
    </div>
    <span>
        <button 
            mat-flat-button
            class="blue-text-button"
            (click)="stopImpersonating()"
        >
            STOP IMPERSONATING
        </button>
    </span>
  </div>
  
